import React from 'react'
import ColorsComponent from '../../components/colors';

const Colors = () => (
  <React.Fragment>
    <div className="page-header">
      <p>Core</p>
      <h1>Colors</h1>
    </div>
    <div className="page-content">
      <ColorsComponent />
    </div>
  </React.Fragment>
)

export default Colors
